import { render, staticRenderFns } from "./OrderActions.vue?vue&type=template&id=b68e6216&scoped=true"
import script from "./OrderActions.vue?vue&type=script&lang=js"
export * from "./OrderActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68e6216",
  null
  
)

export default component.exports